<template lang="pug">
section#MapCenterBuilder
  WtTile(ancestor)
    WtTile(parent vertical :col="2")
    WtTile(parent vertical :col="8")
      WtTile(child :col="12")
        MapBuilder
    WtTile(parent vertical :col="2")
</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import MapBuilder from "@@/MapBuilder/MapBuilder";

export default {
  name: "MapCenterBuilder",

  components: { MapBuilder, WtTile }
};
</script>

<style lang="sass" scoped></style>
